import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ChatSupport} from "./chatSupport";


const routes: Routes = [
  {
    path: 'chatSupport',
    component: ChatSupport,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatSupportRoutingModule {}
